/* ------------------------------------------------------------------------------
* index.js
*
* Implement pub/sub pattern for data communication between different components
* in a browser
*
* Nick Luparev nikita.luparev@gmail.com
------------------------------------------------------------------------------- */

'use strict';

function Amplify () {
  this.slice          = [].slice;
  this.subscriptions  = {};
}

Amplify.prototype.errorValidation = function(data, msg) {
  if ( typeof data !== "string" ) throw new Error( msg );
};

Amplify.prototype.publish = function( topic ) {

  this.errorValidation( topic, "You must provide a valid topic to publish." );

  var args = this.slice.call( arguments, 1 ), // slicing arguments using Array.slice
      topicSubscriptions,
      subscription,
      length,
      i = 0,
      ret;

    if ( !this.subscriptions[ topic ] ) return true;

    // select subscribers for particular topic
    topicSubscriptions = this.subscriptions[ topic ].slice();

    for ( length = topicSubscriptions.length; i < length; i++ ) {
      subscription = topicSubscriptions[ i ];
      ret = subscription.callback.apply( subscription.context, args );

      if ( ret === false ) break;
      
    }
    
    return ret !== false;
};

Amplify.prototype.subscribe = function( topic, context, callback, priority ) {
  this.errorValidation( topic, "You must provide a valid topic to create a subscription." );

  var topicIndex  = 0,
    topics        = topic.split( /\s/ ),
    topicLength   = topics.length,
    added;

  if ( arguments.length === 3 && typeof callback === "number" ) {
    priority  = callback;
    callback  = context;
    context   = null;
  }

  if ( arguments.length === 2 ) {
    callback  = context;
    context   = null;
  }

  priority = priority || 10;

  for ( ; topicIndex < topicLength; topicIndex++ ) {
    topic = topics[ topicIndex ];
    added = false;

    // if such topic doesn't exist create a new one
    if ( !this.subscriptions[ topic ] ) this.subscriptions[ topic ] = [];

    var i = this.subscriptions[ topic ].length - 1,
      subscriptionInfo = {
        callback: callback,
        context: context,
        priority: priority
      };

    for ( ; i >= 0; i-- ) {
      if ( this.subscriptions[ topic ][ i ].priority <= priority ) {
        this.subscriptions[ topic ].splice( i + 1, 0, subscriptionInfo );
        added = true;
        break;
      }
    }

    if ( !added ) {
      this.subscriptions[ topic ].unshift( subscriptionInfo );
    }
  }

  return callback;
};  

Amplify.prototype.unsubscribe = function( topic, context, callback ) {
  this.errorValidation(topic, "You must provide a valid topic to remove a subscription.");

  if ( arguments.length === 2 ) {
    callback  = context;
    context   = null;
  }

  if ( !this.subscriptions[ topic ] ) return;

  var 
    length  = this.subscriptions[ topic ].length,
    i       = 0;

  for ( ; i < length; i++ ) {
    if ( this.subscriptions[ topic ][ i ].callback === callback ) {
      if ( !context || this.subscriptions[ topic ][ i ].context === context ) {
        this.subscriptions[ topic ].splice( i, 1 );
        
        // Adjust counter and length for removed item
        i--;
        length--;
      }
    }
  }
};

var amplify = new Amplify();

module.exports = amplify;

